"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = doesQueryContain;
var _getPotentialAncestors = _interopRequireDefault(require("./getPotentialAncestors.js"));
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function doesQueryContain(document, types, typename, data, predicate) {
  var targetType = types[typename];
  if (!targetType) throw new Error("type not found: ".concat(typename));
  var potentialAncestors = (0, _getPotentialAncestors["default"])(targetType);
  function doesNodeContain(node, data, type) {
    if (type === targetType) {
      if (!predicate || predicate(data)) return true;
    }
    if (!type.name) return false;
    var ancestorEntry = potentialAncestors.get(type);
    if (!ancestorEntry) return false;
    var selectionSet = node.selectionSet;
    if (selectionSet) {
      var _iterator = _createForOfIteratorHelper(selectionSet.selections),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var selection = _step.value;
          var alias = selection.alias;
          var name = selection.name;
          if (!name) continue;
          if (!ancestorEntry.fields.has(name.value)) continue;
          var fields = type.fields;
          if (!fields) continue;
          var field = fields[name.value];
          if (!field) continue;
          var innerType = field.type;
          var list = false;
          while (innerType.ofType) {
            if (innerType.kind === 'LIST') list = true;
            innerType = innerType.ofType;
          }
          var innerData = data ? data[alias ? alias.value : name.value] : null;
          if (predicate && innerData == null) continue;
          if (predicate && list) {
            if (!Array.isArray(innerData)) continue;
            var _iterator2 = _createForOfIteratorHelper(innerData),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var element = _step2.value;
                if (doesNodeContain(selection, element, innerType)) {
                  return true;
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          } else {
            if (doesNodeContain(selection, innerData, innerType)) {
              return true;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return false;
  }
  var _iterator3 = _createForOfIteratorHelper(document.definitions),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var node = _step3.value;
      if (doesNodeContain(node, data, types.Query)) {
        return true;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return false;
}
module.exports = exports.default;